"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.truncate = exports.searchStringCompare = exports.latinize = exports.firstLetterToUpperCase = exports.getFirstLetterUpperCase = void 0;
const tslib_1 = require("tslib");
const latinize_1 = tslib_1.__importDefault(require("latinize"));
const getFirstLetterUpperCase = text => {
  return text.charAt(0).toUpperCase();
};
exports.getFirstLetterUpperCase = getFirstLetterUpperCase;
const firstLetterToUpperCase = text => {
  if (text.length === 0) {
    return text.toUpperCase();
  }
  return text.charAt(0).toUpperCase() + text.slice(1);
};
exports.firstLetterToUpperCase = firstLetterToUpperCase;
const latinize = function () {
  let text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return (0, latinize_1.default)(text);
};
exports.latinize = latinize;
const searchStringCompare = function () {
  let textA = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let textB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  const textAToCompare = (0, exports.latinize)(textA).trim().toLowerCase();
  const textBToCompare = (0, exports.latinize)(textB).trim().toLowerCase();
  return textAToCompare.includes(textBToCompare);
};
exports.searchStringCompare = searchStringCompare;
const truncate = function (text) {
  let noOfCharacters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  if (!text) {
    return text;
  }
  if (text.length > noOfCharacters) {
    return "".concat(text.slice(0, noOfCharacters), "...");
  }
  return text;
};
exports.truncate = truncate;